<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="coursesLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Grupy</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select v-model="selectedYear"  class="choose_year" :items="lookups.years" hide-details ></v-select>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchCourses"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 

                <v-spacer></v-spacer>

                <v-dialog v-if="user.permissions['dictionary'] >= 20" v-model="dialogCopy" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" size="24" class="mr-2" color="primary" >mdi-content-copy</v-icon>
                  </template>
                  <copy-courses @close="closeCopy" :destination="selectedYear"></copy-courses>
                </v-dialog>

                <v-divider
                  v-if="user.permissions['dictionary'] >= 20"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['dictionary'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-dialog v-if="user.permissions['dictionary'] >= 10" v-model="dialog" max-width="700px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="courseAddStatus===1 || courseEditLoadStatus===1 || courseEditStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                           <v-row>                   
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="editedItem.name" :error-messages="nameErrors" required @input="$v.editedItem.name.$touch()"  @blur="$v.editedItem.name.$touch()" counter="20" label="Nazwa"></v-text-field>                            
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="editedItem.room" :error-messages="roomErrors" required @input="$v.editedItem.room.$touch()"  @blur="$v.editedItem.room.$touch()" counter="20" label="Sala"></v-text-field>
                            </v-col>
                            
                           <v-col cols="12" sm="4" md="4">
                                <v-select @change="depChange"  v-model="editedItem.department_id" :items="lookups.departments" :error-messages="departmentErrors" required @input="$v.editedItem.department_id.$touch()"  @blur="$v.editedItem.department_id.$touch()" label="Placówka"></v-select>
                            </v-col>

                            <v-col cols="12" sm="4" md="4">
                              <v-menu
                                ref="menuOd"
                                v-model="menuOd"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="editedItem.from"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                   v-model="editedItem.from" 
                                   :error-messages="fromErrors"  
                                   @input="$v.editedItem.from.$touch()"  
                                   @blur="$v.editedItem.from.$touch()" 
                                   label="Od godziny"
                                   prepend-icon="mdi-clock-outline"
                                   readonly
                                   v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="menuOd"
                                  v-model="editedItem.from"
                                  full-width
                                  format="24hr"
                                  @click:minute="$refs.menuOd.save(editedItem.from)"
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-menu
                                ref="menuDo"
                                v-model="menuDo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="editedItem.to"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                   v-model="editedItem.to" 
                                   :error-messages="toErrors"  
                                   @input="$v.editedItem.to.$touch()"  
                                   @blur="$v.editedItem.to.$touch()" 
                                   label="Do godziny"
                                   prepend-icon="mdi-clock-outline"
                                   readonly
                                   v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="menuDo"
                                  v-model="editedItem.to"
                                  full-width
                                  format="24hr"
                                  @click:minute="$refs.menuDo.save(editedItem.to)"
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                         
                            
                            
                          </v-row>
                        
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Zapisz</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

           <template v-slot:item.department_id="{ item }">
              <span :class="item.department.status?'':'deleted'">{{item.department.name}}</span>
            </template>

           <!-- <template v-slot:item.users="{ item }">
              <div v-html='item.users'/>
            </template> -->
            <template v-slot:item.users="{ item }">
              <v-row class="d-flex flex-row">
                <div dense v-for="val in item.users" :key="val.id" class="ml-1">
                  <span :class="(!val.status)?'deleted':''">{{val.name}} {{val.surname}}</span>
                  <v-icon
                        v-if="val.pivot.temp"
                        size="18"
                        class="mb-1"
                      >
                        mdi-timer-outline
                  </v-icon>
                  <span v-if="item.users.indexOf(val) != item.users.length - 1">, </span>
                </div>
              </v-row>
            </template>

            <template v-slot:item.from="{ item }">
              {{ item.from }} - {{ item.to }}
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip v-if="item.status && user.permissions['dictionary'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.status && item.can_delete && user.permissions['dictionary'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status  && user.permissions['dictionary'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="reactivateItem(item)"
                  >
                    mdi-delete-restore
                  </v-icon>
                  </template>
                  <span>Przywróć</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status && item.can_delete  && user.permissions['dictionary'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    color="error"
                    @click="forceDeleteItem(item)"
                  >
                    mdi-delete-forever
                  </v-icon>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>
            </template> 
            <template v-slot:item.details="{ item }">       
                <v-btn :to="{name:'slowniki.grupa',params:{id:item.id,year_id:item.year_id}}" color="primary" x-small>Detale</v-btn>
            </template> 
            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.status" disabled></v-simple-checkbox>
            </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && coursesLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadCourses" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadCourses" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import confirm from '../components/Confirm'
  import maxLength from 'vuelidate/lib/validators/maxLength'
  import minLength from 'vuelidate/lib/validators/minLength'
  import required from 'vuelidate/lib/validators/required'
  import CopyCourses from "../components/CopyCourses"

  export default {
    components:{
      confirm,
      CopyCourses
    },
    data: () => ({
      menuOd: false,
      menuDo: false,
      componentKey:0,
      tableOptions: {},
      //selectedYear:0,
      dialog: false,
      dialogCopy: false,
      itemEditing:false,
      search:'',
      itemWasDefault:false,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,display:true},
        { text: 'Nazwa', value: 'name',filterable:true,filterColumn:"name",display:true },
        { text: 'Placówka', value: 'department_id',filterable:true,filterColumn:"department.name",display:true },
        { text: 'Nauczyciele', value: 'users',filterable:true,filterColumn:"users.name",display:true,sortable: false },
        { text: 'Nauczyciele', value: 'users.surname',filterable:true,filterColumn:"users.surname",display:false },
        { text: 'Sala', value: 'room',filterable:true,filterColumn:"room",display:true },
        { text: 'Godziny', value: 'from',filterable:true,filterColumn:"from",display:true },
        { text: 'Godziny', value: 'to',filterable:true,filterColumn:"to",display:false },
        { text: 'Dzieci', value: 'children_count',filterable:false,display:true },
        { text: 'Status', value: 'status',filterable:false,display:true },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false,display:true },
        { text: '', value: 'details', sortable: false,filterable:false,display:true },
      ],
    }),
    validations: {
      editedItem:{
        name: {
          required,
          maxLength:maxLength(20),
        },
        department_id:{
          required,
        },
        room:{
          required,
          maxLength:maxLength(20)
        },
        from:{
          required,
        },
        to:{
          required,
        },
       
      }
    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    
      dialog (val) {
        this.$v.$reset()
        val || this.close()
      },
      courseEditStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      courseAddStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      courseDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getCourseOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setCourseOptions', {options:value} )
        }
      },
      selectedYear:{
        get () {
          return this.$store.getters.getCourseOptions.selectedYear;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedYear = value;
          this.options = currentOptions;
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getCourseOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getCourseEdit;
      },
      tableItems(){
        return this.$store.getters.getCourses;
      },
      coursesLoadStatus(){
        return this.$store.getters.getCoursesLoadStatus;
      },
      courseEditLoadStatus(){
        return this.$store.getters.getCourseEditLoadStatus
      },
      courseEditStatus(){
        return this.$store.getters.getCourseEditStatus();
      },
      courseEditText(){
        return this.$store.getters.getCourseEditText
      },
      courseAddStatus(){
        return this.$store.getters.getCourseAddStatus();
      },
      courseAddText(){
        return this.$store.getters.getCourseAddText;
      },
      courseDeleteStatus(){
        return this.$store.getters.getCourseDeleteStatus();
      },
      computedHeaders () {
        var localHeaders = [...this.headers.filter(h => h.display===true)]

        if(!this.showDeleted && this.user.permissions['dictionary'] <= 5) return localHeaders.filter(h => h.value!=='status' && h.value!=='actions')
        else if(this.showDeleted && this.user.permissions['dictionary'] <= 5) return localHeaders.filter(h => h.value!=='actions')
        else if(!this.showDeleted) return localHeaders.filter(h => h.value!=='status')
        else return localHeaders
      },
      formTitle () {
        return !this.itemEditing ? 'Nowa grupa' : 'Edycja grupy'
      },
      nameErrors () {
        const errors = []
        if (!this.$v.editedItem.name.$dirty) return errors
        !this.$v.editedItem.name.required && errors.push('Nazwa jest wymagana')
        !this.$v.editedItem.name.maxLength && errors.push('Nazwa może mieć maksymalnie 20 znaków')
        return errors
      },
      roomErrors () {
        const errors = []
        if (!this.$v.editedItem.room.$dirty) return errors
        !this.$v.editedItem.room.required && errors.push('Sala jest wymagana')
        !this.$v.editedItem.room.maxLength && errors.push('Sala może mieć maksymalnie 20 znaków')
        return errors
      },
      departmentErrors () {
        const errors = []
        if (this.itemEditingPassword ||  !this.$v.editedItem.department_id.$dirty) return errors
        !this.$v.editedItem.department_id.required && errors.push('Placówka jest wymagana')
        return errors
      },
      fromErrors () {
        const errors = []
        if (!this.$v.editedItem.from.$dirty) return errors
        !this.$v.editedItem.from.required && errors.push('Godzina jest wymagana')
        return errors
      },
      toErrors () {
        const errors = []
        if (!this.$v.editedItem.to.$dirty) return errors
        !this.$v.editedItem.to.required && errors.push('Godzina jest wymagana')
        return errors
      },
     
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadCourses();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          //console.log(this.lookups);
          this.loadCourses();
        }, 2000)
      }
    },
    methods: {
      loadCourses(){
        this.search='';
        this.$store.dispatch( 'loadCourses' );
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreCourses' );
      },
      reactivateItem(item){
        this.$store.dispatch( 'editCourseReactivate',{slug:item.id});
      },
      editItem (item) {
        this.itemWasMain = item.main;
        this.itemEditing = true
        this.$store.dispatch( 'loadCourseEdit', {slug:  item.id});  
        this.dialog = true
      },
      deleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz wyłączyć grupę?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteCourse', {slug:  item.id});
            }
        })
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać grupę na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteCourse', {slug:  item.id});
            }
        })
      },
      searchCourses(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'filterColumn'),';');
          this.$store.dispatch( 'searchCourses',{filterableHeaders:filterableHeaders,q:this.search});
        }
      },
      depChange(){
        //console.log(this.editedItem.department_id);
        var d = _.find(this.lookups.departments,{'value':this.editedItem.department_id})
        if(!this.itemEditing && d.from)this.editedItem.from = d.from;//gdy nowa placówka to wpusuje domyśle jak są
        if(!this.itemEditing && d.to)this.editedItem.to = d.to;
      },
      close () {
        this.dialog = false
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadCourseEditDefault'); 
          this.$store.dispatch( 'loadCourseAddDefault');
          this.itemEditing = false
        }, 300)
      },
      closeCopy(){
        this.dialogCopy = false
         this.$v.$reset()
      },
      handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
         
            if (this.itemEditing) {
              //edycja
              this.$store.dispatch( 'editCourse', {
                slug: this.editedItem.id,
                name:  this.editedItem.name,
                year_id: this.editedItem.year_id,
                department_id: this.editedItem.department_id,
                room: this.editedItem.room,
                from: this.editedItem.from,
                to: this.editedItem.to,
              });
            } else {//new item
              this.$store.dispatch( 'addCourse', {
                name:  this.editedItem.name,
                year_id: this.editedItem.year_id,
                department_id: this.editedItem.department_id,
                room: this.editedItem.room,
                from: this.editedItem.from,
                to: this.editedItem.to,
              });

            }
        }
      },
    },
  }
</script>
<style scoped>
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 150px;
}

</style>